// Module
var code = "<div class=\"subscription-info-dialog\"> <div class=\"close_icon\" ng-click=\"cancel()\"></div> <p class=\"popup-title\">Info</p> <hr> <p class=\"popup-context\" ng-if=\"isChildEntity\">Info about scholarship users...</p> <p class=\"popup-context\" ng-if=\"!isChildEntity\">Info about corporate users...</p> </div>";
// Exports
var _module_exports = code;;
var path = 'app/modals/corp-plans-info.modal.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;